import { mapState, mapGetters } from 'vuex'
import { CONTENT_TYPES, savedContentTypeMapping } from '@/util/access_visibility'

const pluralizedContentType = {
  [CONTENT_TYPES.GOAL]: 'goals',
  [CONTENT_TYPES.SUPER_PAGE]: 'goals',
  [CONTENT_TYPES.STRATEGY]: 'strategies',
  [CONTENT_TYPES.RESOURCE]: 'downloadable resources',
  [CONTENT_TYPES.PRESENTLEVEL]: 'present levels'
}

const singularContentType = {
  [CONTENT_TYPES.GOAL]: 'goal',
  [CONTENT_TYPES.SUPER_PAGE]: 'goal',
  [CONTENT_TYPES.STRATEGY]: 'strategy',
  [CONTENT_TYPES.RESOURCE]: 'resource',
  [CONTENT_TYPES.PRESENTLEVEL]: 'present levels'
}

export const libraryQuotasMixin = {
  data() {
    return {
      maxStudentsErrorMessage:
        'You have reached the maximum number of folders. You may delete an existing folder to add a new one.'
    }
  },
  computed: {
    ...mapGetters('contentAccess', [
      'maxStudentsReached',
      'maxContentReachedForStudent',
      'libraryQuotaForContentType'
    ]),
    ...mapState('contentAccess', ['libraryQuotas']),
    ...mapGetters('library', ['folderCount'])
  },
  methods: {
    maxContentTypeErrorMessage(contentType) {
      return `You've reached the maximum number of ${
        pluralizedContentType[contentType]
      } for this student folder. You may delete an existing ${
        singularContentType[contentType]
      } to add a new one.`
    },
    sendMaxContentInFolderEvent(contentType, studentUuid) {
      let blockingQuota = ''
      let savedContentType = savedContentTypeMapping[contentType] || contentType
      let quotaValue = this.libraryQuotaForContentType(savedContentType)

      switch (contentType) {
        case CONTENT_TYPES.GOAL:
        case CONTENT_TYPES.SUPER_PAGE:
          blockingQuota = 'max_goals_per_student'
          break
        case CONTENT_TYPES.STRATEGY:
          blockingQuota = 'max_strategies_per_student'
          break
        case CONTENT_TYPES.PRESENTLEVEL:
          blockingQuota = 'max_presentlevels_per_student'
          break
        case CONTENT_TYPES.RESOURCE:
          blockingQuota = 'max_resources_per_student'
          break
      }

      this.$sendEvent('Content Access Blocked', {
        blocked_action: `Save ${contentType} to Library`,
        blocking_quota: blockingQuota,
        blocking_quota_value: quotaValue,
        student_uuid: studentUuid
      })
    },
    sendMaxStudentsReachedEvent() {
      this.$sendEvent('Content Access Blocked', {
        blocked_action: 'Add Student',
        blocking_quota: 'max_students',
        blocking_count: this.folderCount,
        blocking_quota_value: this.libraryQuotas.maxStudents
      })
    }
  }
}
